import { render, staticRenderFns } from "./FoodGroup.vue?vue&type=template&id=d1b9173a"
import script from "./FoodGroup.vue?vue&type=script&lang=js"
export * from "./FoodGroup.vue?vue&type=script&lang=js"
import style0 from "./FoodGroup.vue?vue&type=style&index=0&id=d1b9173a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports